import React from 'react';

import {SvgProps} from '../../helpers/type';

const Star = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M12.7066 8.48974L10.2642 0.448715L7.82171 8.48974H0.212891L6.42458 12.9224L4.06253 20.5513L10.2642 15.8372L16.4759 20.5513L14.1138 12.9224L20.3155 8.48974H12.7066Z"
                fill="#DABF53"
            />
        </svg>
    );
};

export default Star;
